export default __webpack_public_path__ + "images/824906386e5c12e48b95a221ff36975f-auto.webp";